// extracted by mini-css-extract-plugin
export default {"root":"classes_root__gVNWP","form":"classes_form__iyHn5","funds-origin":"classes_funds-origin__z3QRB"};